import { Component } from '@angular/core';
import { LoginService } from 'src/app/service/login.service';
import { Router } from '@angular/router';
import { Input } from '@angular/core';
@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent {

  @Input () cabecera: string = "";
  constructor(private loginService: LoginService, private router: Router) { }
  
  logout(){
    this.loginService.deleteToken();
    this.router.navigate(['/login']);
  }
}
